import { Message } from '@/graphql/types'
import { faUserMd, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Card } from './Basics'

interface Props {
  message: Message
  lineClamp?: boolean
  className?: string
}

export const MessageCard: React.FC<Props> = ({
  message,
  lineClamp,
  children,
  className,
}) => {
  return (
    <Card
      className={`pt-6 px-4 ${
        message.consulterMessage ? 'bg-white' : 'bg-sub-color'
      } ${className ? className : ''}`}
    >
      <div className="flex">
        <span className="font-bold text-lg text-app-color">
          <FontAwesomeIcon
            style={{ fontSize: 24, marginRight: 7 }}
            icon={message?.consulterMessage ? faUser : faUserMd}
          />
          {message?.consulterMessage
            ? 'ユーザーからの相談'
            : '医療チームが回答'}
        </span>
      </div>
      <p
        className={`mt-2 text-lg whitespace-pre-line ${
          lineClamp ? 'line-clamp-1' : ''
        }`}
      >
        {message.body}
      </p>
      {children}
    </Card>
  )
}

export default MessageCard
